var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-tabs',{attrs:{"background-color":"kbWhite","color":"kbBlue","icons-and-text":""},model:{value:(_vm.currentStatus),callback:function ($$v) {_vm.currentStatus=$$v},expression:"currentStatus"}},[_c('v-tabs-slider'),_vm._l((_vm.statusItems),function(ref,index){
var name = ref.name;
return _c('v-tab',{key:index},[_vm._v(" "+_vm._s(name)+" ")])})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }